/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaItpIncludeFields.tsx
 * FILE_ID: JOBHUB-QA-ITP-INCLUDE-FIELDS-001
 * PURPOSE: Three Include checkboxes for the ITP preview. Each box sits left of its label.
 */
export function QaItpIncludeFields({
  value,
  onChange,
}: {
  value: { product: boolean; requirement: boolean; acceptance: boolean }
  onChange: (key: 'product' | 'requirement' | 'acceptance', next: boolean) => void
}) {
  const rows = [
    ['product', 'Products'],
    ['requirement', 'Requirements'],
    ['acceptance', 'Acceptance criteria'],
  ] as const
  return (
    <fieldset className="min-w-0 space-y-1">
      <legend className="mb-1 text-sm">Include</legend>
      {rows.map(([key, label]) => (
        <label key={key} className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={value[key]}
            onChange={(event) => onChange(key, event.target.checked)}
          />
          <span>{label}</span>
        </label>
      ))}
    </fieldset>
  )
}
